import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { useRouter } from 'next/router';
import { cssColorValue, Type, FormSelect, black, white, screenSmMax, spacer8, spacer16, spacer20, spacer40, spacer24, body1FontSize } from '@spotify-internal/encore-web';
import { lightTheme } from '../Theme';
import { ContentItem } from './ContentItem';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ListWrapper = styled.div.withConfig({
  displayName: "ContentList__ListWrapper",
  componentId: "sc-1j1roln-0"
})(["padding:0px;"]);
var ContentWrapper = styled.div.withConfig({
  displayName: "ContentList__ContentWrapper",
  componentId: "sc-1j1roln-1"
})(["padding:0px;width:100%;:nth-child(odd){background:", ";}:nth-child(even){background:", ";}"], cssColorValue('decorativeSubdued'), cssColorValue('backgroundHighlight'));
var FilterBarWrapper = styled.div.withConfig({
  displayName: "ContentList__FilterBarWrapper",
  componentId: "sc-1j1roln-2"
})(["width:100%;background:", ";padding:", " ", ";display:flex;flex-direction:row;justify-content:space-between;@media (max-width:", "){flex-direction:column;padding:", ";}.SelectContainer{width:30%;}"], function (_ref) {
  var filterBarColor = _ref.filterBarColor;
  return filterBarColor;
}, spacer20, spacer40, screenSmMax, spacer16);
var Headline = styled(Type.h1).attrs({
  paddingBottom: '0.75em',
  variant: 'alto'
}).withConfig({
  displayName: "ContentList__Headline",
  componentId: "sc-1j1roln-3"
})(["color:", ";padding-top:", ";@media (max-width:", "){padding:0px;width:100%;}"], function (_ref2) {
  var filterBarColor = _ref2.filterBarColor;
  return filterBarColor === cssColorValue('decorativeSubdued') ? black : white;
}, spacer24, screenSmMax);
var FilterWrapper = styled.div.withConfig({
  displayName: "ContentList__FilterWrapper",
  componentId: "sc-1j1roln-4"
})(["color:", ";@media (max-width:", "){flex-direction:column;padding-top:", ";width:70%;}"], function (_ref3) {
  var filterBarColor = _ref3.filterBarColor;
  return filterBarColor === cssColorValue('decorativeSubdued') ? black : white;
}, screenSmMax, spacer8);
var Filters = styled.div.withConfig({
  displayName: "ContentList__Filters",
  componentId: "sc-1j1roln-5"
})(["display:flex;flex-direction:row;"]);
var DropDownBox = styled.div.withConfig({
  displayName: "ContentList__DropDownBox",
  componentId: "sc-1j1roln-6"
})(["padding-right:", ";select,input{font-size:", ";}&:last-child{padding:0px;}"], spacer20, body1FontSize);
var FilterHeader = styled(Type.p).attrs({
  variant: 'minuetBold'
}).withConfig({
  displayName: "ContentList__FilterHeader",
  componentId: "sc-1j1roln-7"
})([""]);
var forceEventsList = [{
  title: 'Test Data',
  description: 'Test data to enable LQA',
  franchise: 'NONE',
  image: undefined,
  date: '2900-08-28',
  location: 'Atlanta, USA',
  url: 'https://www.thewilliamsburghotel.com/pool',
  id: '1',
  contentType: 'event',
  urlSlug: 'cao',
  isSearchHit: false,
  score: -1
}];
export var ContentList = function ContentList(props) {
  var t = useT();
  var router = useRouter();
  var emptyTranslation = t('FRODOR_8ea642', 'There are no items matching the specified filters.', '');
  var _props$filterBarTitle = props.filterBarTitle,
      filterBarTitle = _props$filterBarTitle === void 0 ? '' : _props$filterBarTitle,
      filters = props.filters,
      _props$filterBarColor = props.filterBarColor,
      filterBarColor = _props$filterBarColor === void 0 ? black : _props$filterBarColor,
      _props$showFilters = props.showFilters,
      showFilters = _props$showFilters === void 0 ? true : _props$showFilters;
  var _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      _props$emptyMessage = props.emptyMessage,
      emptyMessage = _props$emptyMessage === void 0 ? emptyTranslation : _props$emptyMessage;

  if (router && router.query && router.query._lqa === 'showContentListEmpty') {
    emptyMessage = emptyTranslation;
  }

  if (router && router.query && router.query._lqa === 'showEvents') {
    items = forceEventsList;
  }

  var _React$useState = React.useState(items),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      itemList = _React$useState2[0],
      setItemList = _React$useState2[1];

  function filterDropdown(formValue, filterValue) {
    // @ts-ignore TODO - how to fix this linting error?
    if (formValue !== 'all') {
      var filteredItems = items.filter(function dropdown(item) {
        // @ts-ignore TODO - how to fix this linting error?
        return item[filterValue] === formValue;
      });
      setItemList(filteredItems);
    } else {
      setItemList(items);
    }
  }

  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: lightTheme,
    children: /*#__PURE__*/_jsxs(ListWrapper, {
      children: [/*#__PURE__*/_jsxs(FilterBarWrapper, {
        filterBarColor: filterBarColor,
        children: [/*#__PURE__*/_jsx(Headline, {
          filterBarColor: filterBarColor,
          children: filterBarTitle
        }), filters && showFilters && /*#__PURE__*/_jsxs(FilterWrapper, {
          filterBarColor: filterBarColor,
          children: [/*#__PURE__*/_jsx(FilterHeader, {
            children: t('FRODOR_CONTENT_LIST_SHOW_FILTER', 'Show', 'Show refers to an event')
          }), /*#__PURE__*/_jsx(Filters, {
            children: filters.map(function (filter, key) {
              return /*#__PURE__*/_jsx(DropDownBox, {
                children: /*#__PURE__*/_jsxs(FormSelect, {
                  defaultValue: "all",
                  onChange: function onChange(e) {
                    // @ts-ignore TODO How to remove this linting error?
                    filterDropdown(e.target.value, filter.filterValue);
                  },
                  "data-testid": "dropdown-".concat(filter.filterValue),
                  children: [/*#__PURE__*/_jsx("option", {
                    value: "all",
                    children: filter.allLabel || filter.filterValue.charAt(0).toUpperCase() + filter.filterValue.slice(1)
                  }), filter.filterOptions.map(function (filterOption, index) {
                    return /*#__PURE__*/_jsx("option", {
                      value: filterOption,
                      "data-testid": "option-".concat(filterOption),
                      children: filterOption
                    }, index);
                  })]
                })
              }, key);
            })
          })]
        })]
      }), (itemList.length === 0 || router && router.query && router.query._lqa === 'showContentListEmpty') && /*#__PURE__*/_jsx(ContentWrapper, {
        children: /*#__PURE__*/_jsx(ContentItem, {
          children: emptyMessage
        })
      }), itemList.map(function (item, index) {
        return /*#__PURE__*/_jsx(ContentWrapper, {
          children: /*#__PURE__*/_jsx(ContentItem, _objectSpread({}, item))
        }, index);
      })]
    })
  });
};